export default __webpack_public_path__ + "087d6d48c3656630945a327ded0c1de2.png";